import styled from 'styled-components';

import { grey5 } from 'approot/shared/styles/colours.style';
import { rem } from 'approot/shared/style';
import { spacing12 } from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';

export const SigninType = styled.div`
  ${flexCentreAlignCss}
  border: 1px solid ${grey5};
  border-radius: 50%;
  padding: ${rem(spacing12)};
  width: ${rem(48)};
  height: ${rem(48)};
`;
